import React, { useEffect } from "react";
import { motion } from "framer-motion";
import { useAppContext } from "../context/AppContext";
import { FaArrowUp } from "react-icons/fa";

export default function WithdrawTicker() {
  const { liveWithdrawals, fetchLiveWithdrawals } = useAppContext();

  useEffect(() => {
    fetchLiveWithdrawals();
  }, []);

  // Time format function
  const formatTime = (date) => {
    const seconds = Math.floor((new Date() - new Date(date)) / 1000);
    let interval = Math.floor(seconds / 3600);
    if (interval >= 1) return interval + "h ago";
    interval = Math.floor(seconds / 60);
    if (interval >= 1) return interval + "m ago";
    return "Just now";
  };

  if (!liveWithdrawals || liveWithdrawals.length === 0) return null;

  return (
    // ✅ 3D PERSPECTIVE CONTAINER: perspective-1000 add kiya depth ke liye
    <div className="relative w-full bg-[#020617] border-b border-slate-800 overflow-hidden h-12 flex items-center perspective-1000">
      
      {/* "LIVE" Tag - Fixed Position with a subtle skew */}
      <div className="absolute left-0 z-20 bg-blue-600 h-full px-4 flex items-center gap-2 shadow-[10px_0_30px_rgba(0,0,0,0.5)] transform -skew-x-12 origin-left">
        <span className="relative flex h-2 w-2 transform skew-x-12">
          <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-blue-100 opacity-75"></span>
          <span className="relative inline-flex rounded-full h-2 w-2 bg-white"></span>
        </span>
        <span className="text-[10px] font-black uppercase tracking-[2px] text-white whitespace-nowrap transform skew-x-12">
          Live Payouts
        </span>
      </div>

      {/* Scrolling Container */}
      <div className="flex whitespace-nowrap overflow-hidden ml-36 w-full h-full items-center">
        <motion.div
          className="flex gap-12 items-center px-4"
          animate={{ x: ["0%", "-50%"] }}
          transition={{ ease: "linear", duration: 35, repeat: Infinity }}
        >
          {[...liveWithdrawals, ...liveWithdrawals].map((item, index) => (
            // ✅ 3D SCROLLING ITEM: rotateY, glassmorphism, aur shadow add kiya depth ke liye
            <motion.div 
              key={index} 
              className="flex items-center gap-3 bg-slate-900/40 backdrop-blur-sm border border-slate-700/50 px-4 py-1.5 rounded-full shadow-[0_10px_20px_-5px_rgba(0,0,0,0.3)] transform-style-3d hover:bg-slate-800/60 transition-colors"
              style={{ rotateY: 15 }} // Subtle fixed rotation for depth look
              whileHover={{ rotateY: 0, scale: 1.05 }} // Flattens and pops on hover
            >
              <span className="text-[11px] font-bold text-slate-300">
                {item.userName}
              </span>
              <div className="flex items-center gap-1.5 border-l border-slate-700/50 pl-3">
                <span className="text-[11px] font-black text-white">${item.amount}</span>
                {/* Status Tag - Golden, like the new logo */}
                <div className="flex items-center text-[9px] font-bold text-yellow-400 bg-yellow-400/10 px-1.5 py-0.5 rounded border border-yellow-400/20">
                  <FaArrowUp size={8} className="mr-0.5" /> Approved
                </div>
              </div>
              <span className="text-[9px] text-slate-500 italic lowercase">
                {formatTime(item.time)}
              </span>
            </motion.div>
          ))}
        </motion.div>
      </div>

      {/* Right Gradient Shade for Smooth Exit */}
      <div className="absolute right-0 top-0 h-full w-24 bg-gradient-to-l from-[#020617] to-transparent z-10" />
    </div>
  );
}